import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
// Routes 

// Components 


import LinearProgress from '@mui/material/LinearProgress';

// Icons 

import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

// import Dropdown from './Dropdown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getGroupAccessListWithGroupId, getGroupLogs } from '../../../../routes/hacker/users';
import GroupAccessRow from './GroupAccessRow';
import InfoRow from '../../../general/inputs/InfoRow';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SettingsIcon from '@mui/icons-material/Settings';
import DataBox from '../../../general/data/DataBox';

const GroupLogs: React.FC = () => {

    const { t } = useTranslation();
    
    const dispatch = useAppDispatch();

    const colors = useAppSelector(state => state.theme.colors);  
    const selectedGroup = useAppSelector(state => state.groupsAccess.selectedGroup);  

    const [postionX, setPositionX] = useState(0); 
    const [positionY, setPositionY] = useState(0); 


    const [stopLoading, setStopLoading] = useState(false); 
    const [logsList, setLogsList] = useState([]); 

    // -- 

    const handleGroupLogs = async () => { 

      const res = await getGroupLogs(selectedGroup?._id) as any; 

      if (res.data.status === 200) { 

        setLogsList(res.data.groupLogs);  

        setStopLoading(true); 

      };

    }; 

    // -- 

    const handleSelection = (e: any, group: any) => { 

      setPositionX(e.pageX);
      setPositionY(e.pageY); 

    }; 

    // -- 

    useEffect(() => { 

        if (selectedGroup) { 

            handleGroupLogs(); 

        }; 

    },[selectedGroup]); 

    // -- 
    
    return (

        <DataBox 
            title='Group Logs'
            extraStyle={{ 
                overflow: 'auto',
                marginTop: 2, 
                minHeight: 500, 
            }}
        >

            {logsList?.map((groupLog: any, index: any) => { 

                let icon; 

                if (groupLog?.hackerId) { 
                    icon = <SupportAgentIcon sx={{ color: 'purple' }} />; 
                } else if (groupLog?.doctorId) { 
                    icon = <AccountCircleIcon sx={{ color: colors?.main }} />
                } else { 
                    icon = <SettingsIcon sx={{ color: 'rgb(165, 164, 164)' }} />
                }; 
    
                return <InfoRow
                    key={index}
                    title={moment(groupLog?.createdAt).utc(true).format('LLL')}
                    icon={icon}
                    description={groupLog?.description}
                    descriptionStyle={{ fontSize: 14, color: 'rgb(130, 130, 130)'}}
                />

            })}
        

            {((logsList?.length === 0) && !stopLoading) &&         
          
                <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-evenly', 
                height: '100%',
                width: '80%', 
            }}>

                <Box
                    sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>

                    <LinearProgress sx={{ width: 500, marginBottom: 10 }} /> 

                    <Box>Retrieving Group Logs...</Box>

                </Box>

            </Box>}

        </DataBox>
    
      );

};

export default GroupLogs;